import { Badge } from "@/components/ui/badge";
import { AlertCircle } from "lucide-react";

interface HrgDisplayProps {
  hrgs: {
    id: string;
    hrg: {
      id: string;
      code: string;
      description: string | null;
    };
  }[];
  showEmptyState?: boolean;
}

const HrgDisplay = ({ hrgs, showEmptyState = true }: HrgDisplayProps) => {
  if (hrgs.length === 0) {
    if (!showEmptyState) {
      return null;
    }

    return (
      <div className="flex items-center gap-2 text-sm text-muted-foreground">
        <AlertCircle className="h-4 w-4" />
        <span>HRG processing...</span>
      </div>
    );
  }

  return (
    <div className="flex flex-wrap gap-2">
      {hrgs.map((hrgItem) => (
        <div key={hrgItem.id} className="flex items-center gap-2 px-3 py-1 bg-muted rounded-full text-sm">
          <span className="text-muted-foreground">HRG</span>
          <Badge variant="secondary" className="text-xs">
            {hrgItem.hrg.code}
          </Badge>
        </div>
      ))}
    </div>
  );
};

export default HrgDisplay;
